import React from 'react';

const EmptyFilterResult = ({ message = 'No se encontraron resultados con los filtros aplicados.' }) => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center p-4 w-100 m-auto mb-5 bg-infox"
      style={{ minHeight: '60vh', maxWidth: '700px' }}
    >
      <img alt="empty" src="/img/animation/userNotFound.webp" style={{ width: '150px', height: '150px' }} />
      <h3 className="text-center">{message}</h3>
    </div>
  );
};

export default EmptyFilterResult;
